import { Component, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { UntypedFormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, ControlValueAccessor, Validators, ReactiveFormsModule } from '@angular/forms';
import { Tooltip } from 'src/app/model/tooltip';
import { UtilService } from 'src/app/shared';
import { Router } from '@angular/router';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-email',
    templateUrl: './email.component.html',
    styleUrls: ['./email.component.scss'],
    providers: [
        {
            provide: NG_VALIDATORS, useExisting: EmailComponent, multi: true
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EmailComponent),
            multi: true
        }
    ],
    imports: [ReactiveFormsModule, NgClass]
})
export class EmailComponent implements OnInit {

    onTouched: () => void;
  onChange = (value: string) => { }; 
   


  @Input() controllerData;
  @Input() loggedInFlag;
  @Input() parent: UntypedFormGroup;
  @Input() controlName:string;
  
  @Input() pageName: string;
 
  @Input() dobDisabled = false;
  disabled: boolean;
  private screenName;

  @Output() changeHandler: EventEmitter<any> = new EventEmitter<any>();
  constructor(private utilService: UtilService,
              private router: Router) { }

  ngOnInit() {
    this.getCurrentScreenURL();
    if(this.screenName === 'your health records' || this.screenName === 'dependant health records') {
      this.parent.get(this.controlName).setValidators([]);
    } else {
      this.parent.get(this.controlName).setValidators([Validators.required]);
    }
  }
  writeValue(value: any): void {
    this.controllerData['value'] = value ? value: null;
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  validate() {
    // tslint:disable-next-line: max-line-length
    const nameReForpostCode: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const forbidden = nameReForpostCode.test(this.parent.get(this.controlName).value);

    if (this.parent.get(this.controlName).value) {
      return forbidden ? null : { notValidEmail: true};
      // tslint:disable-next-line:align
      } return null;
  }
  validateInput = () => {
    this.changeHandler.emit();
  }
  getCurrentScreenURL(): string {
		this.screenName = this.utilService.getScreenNameFromURL(this.router.url);
		return this.screenName;
	}

}
